/**
 * Created by vladislav on 24.11.2020
 */

const KeypadLetterView = cc.Node.extend({
    ctor: function (letter, radius) {
        this._super(); 

        this.letter = letter;

        this.radius = radius;

        const styles = cleverapps.styles.KeypadLetterView;

        this.setAnchorPoint(0.5, 0.5);

        this.setContentSize2(styles);

        this.charView = CharView.Create(this.letter.symbol, {
            noBg: cleverapps.styles.KeypadLetterView.noBg,
            bgImage: KeypadLetterView.bgImage,
            whiteLetter: true
        });

        this.addChild(this.charView);

        this.charView.setAlignment(this.width / 2, this.height / 2);

        if (cleverapps.config.name === "wordsoup") {
            const rotations = [-4, 4, 0, -6, 6];

            this.setRotation(rotations[this.letter.symbol.charCodeAt(0) % rotations.length]);
        }

        this.addGlow();

        this.baseRotation = this.getRotation();

        this.letter.on("select", this.select.bind(this), this);
        this.letter.on("unselect", this.unselect.bind(this), this);
        this.letter.on("status", this.status.bind(this), this);
        this.letter.onLocateView = this.createListener(this.locateView.bind(this));

        this.setCascadeOpacityEnabled(true);
        this.setCascadeColorEnabled(true);

        this.onResize();
    },

    addGlow: function () {
        if (!bundles.letters.frames.letter_bg_glow_png) {
            return;
        }

        const glow = this.glow = new cc.Sprite(bundles.letters.frames.letter_bg_glow_png);
        this.addChild(glow, -1);
        glow.setAlignment(cleverapps.styles.KeypadLetterView.glow);
        glow.setOpacity(0);
    },

    onResize: function () {
        this.setAlignment(this.calcPosition(this.letter.index));
    },

    locateView: function () {
        return this;
    },

    select: function () {
        if (cleverapps.styles.FONTS.SELECTED_LETTERS_TEXT && this.charView.letter instanceof cleverapps.UI.LabelTTF) {
            this.charView.letter.setFont(cleverapps.styles.FONTS.SELECTED_LETTERS_TEXT);
        }

        this.showGlow();

        if (cleverapps.config.name === "wordsoup") {
            this.runAction(new cc.Spawn(new cc.ScaleTo(0.2, 1.2), new cc.RotateTo(0.2, this.baseRotation - 4)));
        }
    },

    unselect: function () {
        if (this.charView.letter instanceof cleverapps.UI.LabelTTF) {
            this.charView.letter.setFont(cleverapps.styles.FONTS.LETTERS_TEXT);
        }

        this.hideGlow();

        if (cleverapps.config.name === "wordsoup") {
            this.runAction(new cc.Spawn(new cc.ScaleTo(0.2, 1), new cc.RotateTo(0.2, this.baseRotation)));
        }
    },

    showGlow: function () {
        this.glow.stopAllActions();
        this.glow.runAction(new cc.FadeTo(0.2, 255));
    },

    hideGlow: function () {
        this.glow.stopAllActions();
        this.glow.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.FadeTo(0.3, 0)
        ));
    },

    status: function (code) {
        this.charView.stopAllActions();
        this.stopAllActions();

        this.unselect();

        const dx = cleverapps.styles.KeypadLetterView.wrongAnimation.dx;
        if (code === WordGame.STATUSES.WRONG) {
            this.runAction(
                new cc.Sequence(
                    new cc.MoveBy(0.07, dx, 0),
                    new cc.MoveBy(0.06, -dx, 0),
                    new cc.MoveBy(0.05, dx, 0),
                    new cc.MoveBy(0.04, -dx, 0)
                )
            );
        }

        let delay = 0.22;
        if (cleverapps.config.name === "wordsoup") {
            delay = 0.4;
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.CallFunc(() => {
                this.setScale(1);
                this.setRotation(this.baseRotation);
            })
        ));
    },

    isTouched: function (touch) {
        const point = this.convertTouchToNodeSpace(touch);

        if (cleverapps.config.name === "wordsoup") {
            if (this.letter.selected) {
                return cc.rectContainsPoint(cc.rect(this.width / 4, this.height / 4, this.width * 3 / 4, this.height * 3 / 4), point);
            }
            return cc.rectContainsPoint(cc.rect(0, 0, this.width, this.height), point);
        }

        const dir = cc.p(this.x - this.parent.width / 2, this.y - this.parent.height / 2);
        const length = Math.sqrt(dir.x * dir.x + dir.y * dir.y);
        const unitDir = cc.p(dir.x / length, dir.y / length);

        const hitBox = cleverapps.styles.KeypadLetterView.hitBox;
        const center = cc.p(this.width / 2 + unitDir.x * hitBox.offset, this.height / 2 + unitDir.y * hitBox.offset);
        const radius = hitBox.radius;

        return (point.x - center.x) * (point.x - center.x) + (point.y - center.y) * (point.y - center.y) <= radius * radius;
    },

    getShuffleFinishPosition: function () {
        let finishPoint = this.calcPosition(this.letter.index);

        finishPoint = cc.p(
            this.calculateAxis(finishPoint.x, "x", this.parent.width),
            this.calculateAxis(finishPoint.y, "y", this.parent.height)
        );

        return finishPoint;
    },

    calcPosition: function (index) {
        const alpha = 2 * Math.PI / this.letter.keypad.letters.length;
        const angle = alpha * index;
        const dx = this.radius * Math.sin(angle);
        const dy = this.radius * Math.cos(angle);

        return {
            x: { align: "center", dx },
            y: { align: "center", dy }
        };
    },

    getPathPosition: function () {
        const alpha = 2 * Math.PI / this.letter.keypad.letters.length;
        const angle = alpha * this.letter.index;
        return cc.p(this.parent.width / 2 + this.radius * Math.sin(angle), this.parent.height / 2 + this.radius * Math.cos(angle));
    },

    chooseLetterAnimation: function (index) {
        index = index || 1;
        this.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.DelayTime(index * 0.16 + Math.random() / 10),
                StandartAnimations.shake(this, {
                    power: 0.5,
                    points: [
                        { x: 3, y: 3, r: 0 },
                        { x: 3, y: -3, r: 0 },
                        { x: 0, y: 0, r: 0 },
                        { x: 0, y: 3, r: 0 },
                        { x: 3, y: -3, r: 0 },
                        { x: 0, y: 0, r: 0 }
                    ],
                    moveTime: 0.09
                })
            )
        ));

        this.hoverHandler = cleverapps.UI.applyHover(this, {
            onMouseOver: function () {
                this.setScale(1.2);
            }.bind(this),

            onMouseOut: function () {
                this.setScale(1);
            }.bind(this)
        });
    },

    enable: function () {
        this.setOpacity(255);
    },

    disable: function () {
        this.setOpacity(55);
    }
});

cleverapps.styles.KeypadLetterView = {
    shuffleRadius: 100,

    width: 90,
    height: 90,

    wrongAnimation: {
        dx: 10
    },

    hitBox: {
        radius: 60,
        offset: 15
    },

    chooseLetter: {
        x: { align: "center" },
        y: { align: "center" }
    },

    glow: {
        x: { align: "center" },
        y: { align: "center" }
    }
};